import component from './ProfileDropdown.vue'
export default component
